export const FEFOPAGE = () => `/fefo`;
